var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNeedroom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 79 95"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.675
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.267 77.076c-.541 2.831-1.504 5.663-2.948 8.248-.602 1.108-.18 2.4.903 2.954 2.105 1.047 5.655 2.647 9.927 3.694 4.632 1.169 10.167 1.785 15.702.553 1.144-.246 1.865-1.354 1.685-2.523-.481-2.462-.782-7.079 1.263-12.988.241-.677.843-1.23 1.565-1.354 12.213-2.093 21.538-12.988 21.538-26.098 0-7.387-2.948-14.034-7.7-18.897-6.558-6.586-17.328-5.54-22.682 2.154-3.129 4.494-8.243 9.11-16.305 10.341-1.925.308-3.85 0-5.715-.554-1.023-.308-2.287-.184-3.61 1.17-3.129 3.262-.963 12.741 2.707 13.603.301.061.602.123.842.123 1.023 0 2.106.739 2.527 1.723.06.124 1.264 2.77.602 6.34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.189 61.098s-5.149 5.05-16.051 1.273"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.92 77.149C11.045 71.302 1.333 57.39 1.333 41.142c0-21.48 17.07-38.899 38.122-38.899 21.051 0 38.122 17.419 38.122 38.9 0 6.216-1.93 12.248-4.464 17.48"
}))));
export default SvgNeedroom;